module.exports = __webpack_public_path__ + "img/normal-login.26df996a.png";